var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"md":"12"}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"hide-default-footer":true,"single-select":_vm.singleSelect,"item-key":"id","show-select":"","headers":_vm.headers},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }